module.exports = __webpack_public_path__ + "img/inno-popup.70b2bcfa.png";